import { apiFetch } from "../../api";
import { BASE_URL as u } from "../../../commonUrls";

const BASE = `${u}/trading-strategy`;

export const getStrategies = () =>
  apiFetch(`${BASE}`).then(r => r.json());

export const createStrategy = (data) =>
  apiFetch(`${BASE}`, { method: "POST",
    headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) }).then(r => r.json());

export const seedStrategies = () =>
  apiFetch(`${BASE}/seed`, { method: "POST" }).then(r => r.json());

export const updateStrategy = (strategyId, data) =>
  apiFetch(`${BASE}/${strategyId}`, { method: "PUT",
    headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) }).then(r => r.json());

export const deleteStrategy = (strategyId) =>
  apiFetch(`${BASE}/${strategyId}`, { method: "DELETE" });

export const getRules = (strategyId) =>
  apiFetch(`${BASE}/${strategyId}/rules`).then(r => r.json());

export const addRule = (strategyId, data) =>
  apiFetch(`${BASE}/${strategyId}/rules`, { method: "POST",
    headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) }).then(r => r.json());

export const updateRule = (strategyId, ruleId, data) =>
  apiFetch(`${BASE}/${strategyId}/rules/${ruleId}`, { method: "PUT",
    headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) }).then(r => r.json());

export const deleteRule = (strategyId, ruleId) =>
  apiFetch(`${BASE}/${strategyId}/rules/${ruleId}`, { method: "DELETE" });

export const runScreener = () =>
  apiFetch(`${BASE}/screener`).then(r => r.json());

export const getSignalsForSymbol = (symbol, avgCost) => {
  const qs = avgCost ? `?avgCost=${avgCost}` : "";
  return apiFetch(`${BASE}/signals/${encodeURIComponent(symbol)}${qs}`).then(r => r.json());
};
